export const CONSTANTS = {
  ARRAY_FIRST_VALUE: 0,
  ARRAY_HAS_NO_VALUE: 0,
  BROWSER_LOCATION: {
    COUNTRY: "country",
    LOCALITY: "locality",
  },
  BUTTON_COLORS: {
    DANGER: "danger",
    LIGHT: "light",
    LINK: "link",
    PRIMARY: "primary",
    SECONDARY: "secondary",
  } as const,
  CACHE_TIME: {
    THIRTY_SECONDS: 30000,
  },
  CARD: {
    AMEX: "AMEX",
    CARD: "card",
    CARD_MASKED: "Card ••••",
    DANGER: "danger",
    DEFAULT_BRAND: "Card",
    DEFAULT_BRAND_UPPER: "CARD",
    DEFAULT_CURRENCY: "CHF",
    DOTS: "••••",
    LAST_FOUR_DIGITS_LENGTH: 4,
    LINK: "link",
    MASKED_DOTS: "•••",
    MASTERCARD: "MASTERCARD",
    NEW: "new",
    TWINT: "TWINT",
    TWINT_BRAND: "TWINT",
    TWINT_INITIAL: "T",
    TWINT_LOWER: "twint",
    TWINT_MASKED: "Twint ••••",
    VISA: "VISA",
  },
  DATE_FORMATS: {
    DAY_MONTH_NAME_YEAR_FORMAT: "D MMMM YYYY",
    DAY_MONTH_YEAR_FORMAT: "DD.MM.YYYY",
    DAY_MONTH_YEAR_HYPHEN_FORMAT: "DD-MM-YYYY",
    DAY_NAME_DAY_MONTH_YEAR_FORMAT: "dd DD.MM.YYYY",
    DAY_SHORT_MONTH_FORMAT: "ddd DD MMM",
    HOUR_MINUTE_FORMAT: "HH:mm",
    YEAR_MONTH_DAY_HYPHEN_FORMAT: "YYYY-MM-DD",
    YEAR_MONTH_DAY_TIME_FORMAT: "YYYY-MM-DD HH:mm",
    YEAR_MONTH_DAY_TIME_SECONDS_FORMAT: "YYYY-MM-DD HH:mm:ss",
  } as const,
  DEFAULT_VALUE: 0,
  ENGLISH_LANGUAGE: "en",
  GREETING_HOURS: {
    AFTERNOON: 12,
    EVENING: 18,
    MORNING: 6,
  } as const,
  HEADER: {
    HEADER: "header",
  },
  HTTP_STATUS: {
    BAD_REQUEST: 400,
    DEVICE_DISCONNECTED: 423,
    DEVICE_ERROR: 412,
    FORBIDDEN: 403,
    INTERNAL_SERVER_ERROR: 500,
    INVALID_DATA: 422,
    NOT_FOUND: 404,
    SUCCESS: 200,
    UNAUTHORIZED: 401,
  },
  IS_BOOKING: "booking",
  IS_CURRENT_USER: 1,
  IS_NOT_EDIT_BOOKING: false,
  KEYBOARD_KEYS: {
    ARROW_LEFT: "ArrowLeft",
    ARROW_RIGHT: "ArrowRight",
    BACKSPACE: "Backspace",
    DELETE: "delete",
    ENTER: "Enter",
    SPACE: " ",
  },
  KM: "KM",
  LANGUAGES: {
    DE: "DE",
    EN: "EN",
    FR: "FR",
    IT: "IT",
  },
  LOCAL_STORAGE: {
    ACCESS_TOKEN: "ACCESS_TOKEN",
    REFRESH_TOKEN: "REFRESH_TOKEN",
    RESERVATIONS_SEARCH_QUERY: "reservations_search_query",
  },
  LOCALES: {
    EN_GB: "en-GB",
  },
  LOCATION_SUPPORT_URLS: {
    CHROME: "https://support.google.com/chrome/answer/142065",
    EDGE: "https://support.microsoft.com/en-us/edge/location-and-privacy-in-microsoft-edge",
    FIREFOX:
      "https://support.mozilla.org/en-US/kb/does-firefox-share-my-location-websites",
    SAFARI:
      "https://support.apple.com/en-in/guide/personal-safety/ips9bf20ad2f/web",
  },
  MEMBER: {
    NO_MEMBER: 0,
    ONE_MEMBER: 1,
  },
  MIN_DISTANCE_KM: 0.1,
  OTHERS: {
    MORE: "...",
  },
  PAGINATION: {
    ITEMS_PER_PAGE_LIMIT_10: 10,
    ITEMS_PER_PAGE_LIMIT_24: 24,
  },
  PHONE_INPUT: {
    DEFAULT_COUNTRY_CODE: "+41",
    MAX_LENGTH: 15,
  },
  RECAPTCHA_INVALID_MESSAGE: {
    EMPTY: "captcha.empty",
    INVALID: "captcha.invalid",
  },
  RECAPTCHA_VERSION: {
    V2: "V2",
    V3: "V3",
  },
  RESERVATION_TABS: {
    CANCELLED: "cancelled",
    FUTURE: "future",
    PAST: "past",
    TODAY: "today",
  },
  STATUS: {
    FAILED: "failed",
    SUCCESS: "success",
  },
  TERMINOLOGY: {
    LOCATION: "Location",
    LOCATIONS: "Locations",
    UNIT: "Unit",
    UNITS: "Units",
  },
  TIME_UNIT: {
    DAY: "day",
  } as const,
  TOAST_AUTO_CLOSE: {
    THOUSAND_FIVE_HUNDRED: 1500,
    TWENTY_THOUSAND: 20000,
  },
  TOAST_POSITION: {
    BOTTOM_CENTER: "bottom-center",
    TOP_CENTER: "top-center",
    TOP_RIGHT: "top-right",
  },
  TOAST_TYPE: {
    ERROR: "error",
    INFO: "info",
    SUCCESS: "success",
    WARNING: "warning",
  },
  TODAY: "today",
  USER_INFO: {
    INFO: "info",
    MEMBER: "MEMBERS",
    RESERVATIONS: "reservations",
  },
  VAT_STANDARD_RATE: 7.7,
  ZERO: 0,
} as const;
